import React from "react";
import { FaDownload } from "react-icons/fa";
import { SecondaryButton } from "../../UI/DesignStandards";
import { notify } from "../../UI/DesignStandards/Notifications/notify";

const CSVExportButton = ({ data }) => {
  const exportScoresToCSV = () => {
    if (!data?.teams || data.teams.length === 0) {
      notify.warning("No teams data available to export");
      return;
    }

    // Get all unique events from the tournament
    const allEvents = new Set();
    data.teams.forEach((team) => {
      team.bowlers?.forEach((bowler) => {
        bowler.eventEntries?.forEach((event) => {
          allEvents.add(event.name);
        });
      });
    });

    const eventNames = Array.from(allEvents).sort();

    // CSV headers
    const headers = [
      "Bowler",
      "Bowler ID",
      "Team ID",
      "Team Name",
      "Squad",
      "Squad Time",
      "Average",
      "Handicap",
      "Scratch Total",
      "Handicap Total",
      "Team Scratch Total",
      "Team Handicap Total",
      ...eventNames.map((event) => event),
    ];

    // Generate CSV rows - one row per bowler per team
    const rows = data.teams.flatMap((team) => {
      const teamScratchTotal = team.teamTotals?.scratchTotal || 0;
      const teamHandicapTotal = team.teamTotals?.handicapTotal || 0;

      return (
        team.bowlers?.map((bowler) => {
          // Get bowler totals from cache if available
          const bowlerScratchTotal = bowler.scratchTotal || 0;
          const bowlerHandicapTotal = bowler.handicapTotal || 0;

          // Get event entries for this bowler
          const bowlerEvents = bowler.eventEntries || [];
          const bowlerEventNames = bowlerEvents.map((e) => e.name);

          // Create base row with bowler and team info
          const baseRow = [
            bowler.name || "",
            bowler.id || "",
            team.id || "",
            team.teamName || "",
            team.squad?.squadDate || "",
            team.squad?.squadTime || "",
            bowler.average || 0,
            bowler.handicap || 0,
            bowlerScratchTotal,
            bowlerHandicapTotal,
            teamScratchTotal,
            teamHandicapTotal,
          ];

          // Add event columns - "Entered" or "Not Entered"
          const eventColumns = eventNames.map((eventName) => {
            return bowlerEventNames.includes(eventName)
              ? "Entered"
              : "Not Entered";
          });

          return [...baseRow, ...eventColumns];
        }) || []
      );
    });

    // Escape CSV values (handle commas, quotes, newlines)
    const escapeCSVValue = (value) => {
      if (value === null || value === undefined) return "";
      const stringValue = String(value);
      if (
        stringValue.includes(",") ||
        stringValue.includes('"') ||
        stringValue.includes("\n")
      ) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    };

    // Convert to CSV format
    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.map(escapeCSVValue).join(",")),
    ].join("\n");

    // Create and download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `tournament-scores-${
      new Date().toISOString().split("T")[0]
    }.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <SecondaryButton
      onClick={exportScoresToCSV}
      icon={FaDownload}
      className="flex items-center gap-2 !px-3 !py-2 text-sm"
      title="Export all scores"
    >
      Export
    </SecondaryButton>
  );
};

export default CSVExportButton;
